import { Button, Modal } from 'antd';
import { t } from 'i18next';
import IconFail from '../../../assets/Images/icons/icon-fail';

const ModalStop = ({
    open,
    text = 'Lorem ipsum dolor sit amet',
    handelClose,
    handelOk,
    loading,
    isConfirm = true,
}) => {
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                <IconFail />
                <div className="text-2xl font-semibold">
                    {t('common.ConfirmStopProcess')}
                </div>
                <div>{text}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                {isConfirm ? (
                    <>
                        <Button
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            loading={loading}
                            onClick={handelOk}
                            size="large"
                            type="primary"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </>
                ) : (
                    <Button onClick={handelOk} size="large" type="primary">
                        {t('common.Close')}
                    </Button>
                )}
            </div>
        </Modal>
    );
};
export default ModalStop;
